/* eslint-disable @typescript-eslint/no-explicit-any */
import { abortable as abortableBase } from "@enfusion-ui/utils";
import queryString from "query-string";
import { fillVoiceOrderFactory, getOrderFactory, getSplitOrderFactory, saveAndTransmitOrderFactory, saveOrderFactory, } from "./utils/oems";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    return {
        FILL_VOICE_ORDER: fillVoiceOrderFactory(restServer),
        SAVE_AND_TRANSMIT_ORDER: saveAndTransmitOrderFactory(restServer),
        SAVE_ORDER: saveOrderFactory(restServer),
        GET_SPLIT_ORDER: getSplitOrderFactory(restServer),
        GET_ORDER: getOrderFactory(restServer),
        TRANSMIT_ORDER: abortable((orderId, transmitWithWarnings = false) => [
            queryString.stringifyUrl({
                url: `/internal/api/oms/v1/orders/transmit/${orderId}`,
                query: { transmitWithWarnings },
            }),
            { method: "POST" },
        ]),
        CANCEL_ORDER: abortable((orderId) => [
            `/internal/api/oms/v1/orders/cancel/${orderId}`,
            { method: "POST" },
        ]),
        GET_FILLS: abortable((orderId) => `/internal/api/oms/v1/orders/fills/${orderId}`),
        GET_CALCULATED_VALUE: abortable((body) => ["/internal/api/oms/v1/calculator", { body }]),
        GET_LOCATES: abortable((instrumentId) => `/internal/api/oms/v1/orders/locates/${instrumentId}`),
        GET_LOCATES_PATH: (instrumentId) => `/internal/api/oms/v1/orders/locates/${instrumentId}`,
        GET_LOCATE_BROKERS_PATH: () => "/internal/api/oms/v1/orders/locates/brokers",
        GET_LOCATE_BROKERS_CUSTOM_PATH: () => "/internal/api/oms/v1/orders/locates/brokers/custom",
        GET_ALL_LOCATES: abortable(() => "/internal/api/oms/v1/orders/locates/all"),
        GET_ALL_POSITIONS: abortable(() => "/internal/api/reports/oms/positions"),
        GET_LIMIT_PRICE: abortable((instrumentId, orderSide, financialSubType) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/orders/limit/quote",
            query: { instrumentId, orderSide, financialSubType },
        })),
        GET_OEMS_POSITIONS: abortable((instrumentId, activeOnly, positionDate) => [
            "/internal/api/reports/oms/position",
            {
                body: { instrumentId, activeOnly, positionDate },
            },
        ]),
        GET_PREFERRED_ALLOCATION_SCHEMES: abortable(() => "/internal/api/oms/v1/allocation/schemes/preferred"),
        GET_ALL_ALLOCATION_SCHEMES: abortable(() => "/internal/api/oms/v1/allocation/schemes"),
        GET_ALLOCATION_SCHEME: abortable((schemeId, body) => [
            queryString.stringifyUrl({
                url: "/internal/api/oms/v1/allocation/schemes/apply",
                query: { schemeId },
            }),
            { body },
        ]),
        APPLY_ALLOCATION_TEMPLATE: abortable((body) => ["/internal/api/oms/v1/allocation/templates/apply", { body }]),
        APPLY_SWAP_CHECK: abortable((body) => ["/internal/api/oms/v1/order/apply-swap-check", { body }]),
        GET_PREFERRED_EXECUTION_SCHEMES: abortable((instrumentId, financialType, isSwap, tradingDeskId) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/schemes/preferred",
            query: {
                instrumentId,
                financialType,
                isSwap,
                tradingDeskId,
            },
        })),
        GET_ALL_EXECUTION_SCHEMES: abortable((instrumentId, financialType, isSwap, tradingDeskId) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/schemes",
            query: {
                instrumentId,
                financialType,
                isSwap,
                tradingDeskId,
            },
        })),
        GET_DEFAULT_ORDER: abortable((instrumentId) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/orders/default",
            query: { instrumentId },
        })),
        GET_COMPLIANCE: abortable((orderId) => `/internal/api/oms/v1/orders/compliance/${orderId}`),
        RUN_COMPLIANCE: abortable((orderId) => [
            `/internal/api/oms/v1/orders/compliance/run/${orderId}`,
            { method: "POST" },
        ]),
        GET_ACCOUNTS: abortable(() => "/internal/api/oms/v1/accounts"),
        GET_ALLOCATIONS_TEMPLATES: abortable(() => "/internal/api/oms/v1/allocation/templates"),
        GET_TABLE_METADATA: abortable(() => "/internal/api/oms/v1/orders/table/metadata"),
        GET_COMPLIANCE_TEMPLATES: abortable(() => "/internal/api/oms/v1/orders/compliance/templates"),
        GET_COMPLIANCE_RULES: abortable(() => "/internal/api/oms/v1/orders/compliance/rules"),
        GET_COMPLIANCE_RULES_PATH: () => "/internal/api/oms/v1/orders/compliance/rules",
        GET_QUOTES: abortable((orderId) => `/internal/api/oms/v1/orders/quotes/${orderId}`),
        GET_OMS_PREFERENCES: abortable(() => "/internal/api/oms/v1/prefs"),
        GET_OMS_SETTINGS: abortable(() => "/internal/api/oms/v1/settings"),
        IS_ORDER_TRANSMITTABLE: abortable((body) => ["/internal/api/oms/v1/orders/transmittable", { body }]),
        GET_ELECTRONIC_ROUTING_TARGETS_PATH: (isSwap = false, financialType, instrumentId) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/targets",
            query: {
                financialType,
                instrumentId,
                isSwap,
            },
        }),
        GET_ELECTRONIC_ROUTING_BROKER_ACCOUNTS: abortable((targetCompId, destination) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/brokeraccounts",
            query: {
                targetCompId,
                destination,
            },
        })),
        GET_ELECTRONIC_ROUTING_BROKER_ACCOUNTS_PATH: (targetCompId, destination) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/brokeraccounts",
            query: {
                targetCompId,
                destination,
            },
        }),
        GET_ELECTRONIC_ROUTING_STRATEGY: abortable((targetCompId, destination, instrumentId, financialSubType) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/strategies",
            query: {
                targetCompId,
                destination,
                instrumentId,
                financialSubType,
            },
        })),
        GET_ELECTRONIC_ROUTING_STRATEGY_PATH: (targetCompId, destination, instrumentId, financialSubType) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/execution/strategies",
            query: {
                targetCompId,
                destination,
                instrumentId,
                financialSubType,
            },
        }),
        CALCULATE_VARIANCE_NOTIONAL: abortable((body) => [
            "/internal/api/oms/v1/varianceSwapCalculator",
            { body },
        ]),
        GET_ELECTRONIC_ROUTING_DESTINATIONS: abortable((body) => ["/internal/api/oms/v1/execution/destinations", { body }]),
        GET_ORDER_COLUMNS: abortable((mobile = false) => queryString.stringifyUrl({
            url: "/internal/api/oms/v1/orders/views",
            query: { mobile },
        })),
        SAVE_ORDER_COLUMNS: abortable((body, mobile = false) => [
            queryString.stringifyUrl({
                url: "/internal/api/oms/v1/orders/views/save",
                query: { mobile },
            }),
            { body },
        ]),
        GET_QUICK_ENTRY_CALCULATION: abortable((body) => ["/internal/api/oms/v1/orders/quickentry", { body }]),
        GET_ALLOCATION_REASON_TEMPLATES_PATH: () => "/internal/api/oms/v1/allocation/reason/templates",
        GET_TRADE_REASON_TEMPLATES_PATH: () => "/internal/api/oms/v1/trade/reason/templates",
        GET_DARK_POOLS_PATH: () => "/internal/api/oms/v1/darkpools",
        GET_OPTIMIZE_TYPES: () => "/internal/api/oms/v1/allocation/optimize/types",
        GET_DAY_COUNTS: () => restServer("/internal/api/oms/v1/daycounts"),
        GET_OPTIMIZED_ALLOCATION_QTY: abortable((body) => ["/internal/api/oms/v1/allocation/optimize", { body }]),
        GET_OPTIMIZED_ALLOCATION: abortable((orderId) => `/internal/api/oms/v1/allocation/optimize/${orderId}`),
        VALIDATE_STRATEGY_PARAMS: abortable((body) => ["/internal/api/oms/v1/orders/strategy/validate", { body }]),
    };
};
